import { useEffect, useRef } from 'react'

import { logAmplitude } from './useAmplitude'

export function useLogOnce(
  eventName: string,
  payload?: Record<string, any>,
  shouldLog: boolean = true,
) {
  const hasLoggedRef = useRef(false)

  useEffect(() => {
    if (!hasLoggedRef.current && payload && shouldLog) {
      logAmplitude(eventName, payload)
      hasLoggedRef.current = true
    }
  }, [eventName, payload, shouldLog])
}
